<span [ngClass]="getStatusClass()">{{ getStatusText() }}</span>
